(function () {
  var PRINT_PATTERNS = {
    unframed: /unframed/i,
    canvas: /canvas/i,
    black: /black/i,
    wood: /wood|natural/i
  };

  function findValue(inputs, pattern) {
    var input = inputs.find(function (item) { return pattern.test(item.value); });
    return input ? input.value : null;
  }

  function optionImage(input) {
    if (!input) return null;
    var label = input.closest('label');
    var image = label && label.querySelector('.emmi-option-image img');
    if (!image) return null;
    return { src: image.currentSrc || image.src, alt: image.alt || '' };
  }

  function makeButton(label, value, image) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'emmi-option-pill';
    button.dataset.value = value;
    button.setAttribute('aria-pressed', 'false');
    if (image && image.src) {
      var wrap = document.createElement('span');
      wrap.className = 'emmi-option-image';
      wrap.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.src = image.src;
      img.alt = image.alt;
      img.loading = 'lazy';
      wrap.appendChild(img);
      button.appendChild(wrap);
    }
    var text = document.createElement('span');
    text.textContent = label;
    button.appendChild(text);
    return button;
  }

  function makeGroup(name, choices) {
    var fieldset = document.createElement('fieldset');
    fieldset.className = 'emmi-proxy-option';
    fieldset.dataset.emmiGroup = name.toLowerCase();
    var legend = document.createElement('legend');
    legend.textContent = name;
    fieldset.appendChild(legend);
    choices.forEach(function (choice) {
      fieldset.appendChild(makeButton(choice.label, choice.value, choice.image));
    });
    return fieldset;
  }

  function enhance(picker) {
    if (!picker) return;
    if (picker.dataset.emmiEnhanced === 'true') {
      if (picker.querySelector('[data-emmi-group="material"]')) return;
      picker.dataset.emmiEnhanced = 'false';
    }
    var form = picker.querySelector('.variant-picker__form');
    if (!form) return;

    var fieldsets = Array.from(form.querySelectorAll('fieldset.variant-option--buttons'));
    var source = fieldsets.find(function (fieldset) {
      var values = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map(function (input) {
        return input.value;
      });
      return values.some(function (value) { return PRINT_PATTERNS.unframed.test(value); }) &&
        values.some(function (value) { return PRINT_PATTERNS.canvas.test(value); });
    });
    if (!source) return;

    var inputs = Array.from(source.querySelectorAll('input[type="radio"]'));
    var values = {
      unframed: findValue(inputs, PRINT_PATTERNS.unframed),
      canvas: findValue(inputs, PRINT_PATTERNS.canvas),
      black: findValue(inputs, PRINT_PATTERNS.black),
      wood: findValue(inputs, PRINT_PATTERNS.wood)
    };
    if (!values.unframed || !values.canvas) return;

    picker.dataset.emmiEnhanced = 'true';
    source.classList.add('emmi-native-print-option');

    var inputFor = function (value) {
      return inputs.find(function (input) { return input.value === value; });
    };

    var material = makeGroup('Material', [
      { label: 'Fine Art Giclée', value: 'giclee', image: optionImage(inputFor(values.unframed)) },
      { label: 'Canvas', value: 'canvas', image: optionImage(inputFor(values.canvas)) }
    ]);
    var frameChoices = [
      { label: 'No frame', value: 'none', image: optionImage(inputFor(values.unframed)) }
    ];
    if (values.black) frameChoices.push({ label: 'Black', value: 'black', image: optionImage(inputFor(values.black)) });
    if (values.wood) frameChoices.push({ label: 'Wood', value: 'wood', image: optionImage(inputFor(values.wood)) });
    var frame = makeGroup('Frame', frameChoices);

    var sizeFieldset = fieldsets.find(function (fieldset) { return fieldset !== source; });
    if (sizeFieldset) {
      sizeFieldset.dataset.emmiSize = 'true';
      var sizeLegend = sizeFieldset.querySelector('legend');
      if (sizeLegend) sizeLegend.textContent = 'Size';
    }

    source.before(material);
    if (sizeFieldset) sizeFieldset.after(frame);
    else material.after(frame);

    var lastGicleeFrame = 'none';

    function selectNative(value) {
      var input = inputFor(value);
      if (input && !input.checked) input.click();
    }

    function currentNativeValue() {
      var checked = inputs.find(function (input) { return input.checked; });
      return checked ? checked.value : values.unframed;
    }

    function sync() {
      var current = currentNativeValue();
      var isCanvas = current === values.canvas;
      var frameValue = current === values.black ? 'black' : current === values.wood ? 'wood' : 'none';
      if (!isCanvas) lastGicleeFrame = frameValue;

      material.querySelectorAll('.emmi-option-pill').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.value === (isCanvas ? 'canvas' : 'giclee')));
      });
      frame.querySelectorAll('.emmi-option-pill').forEach(function (button) {
        var framedChoice = button.dataset.value !== 'none';
        button.disabled = isCanvas && framedChoice;
        button.setAttribute('aria-disabled', String(button.disabled));
        button.setAttribute('aria-pressed', String(button.dataset.value === (isCanvas ? 'none' : frameValue)));
        if (button.disabled) button.title = 'Black and wood frames are available with Fine Art Giclée.';
        else button.removeAttribute('title');
      });
    }

    material.addEventListener('click', function (event) {
      var button = event.target.closest('.emmi-option-pill');
      if (!button) return;
      if (button.dataset.value === 'canvas') {
        selectNative(values.canvas);
      } else {
        var target = lastGicleeFrame === 'black' ? values.black :
          lastGicleeFrame === 'wood' ? values.wood : values.unframed;
        selectNative(target || values.unframed);
      }
      window.setTimeout(sync, 0);
    });

    frame.addEventListener('click', function (event) {
      var button = event.target.closest('.emmi-option-pill');
      if (!button || button.disabled) return;
      var target = button.dataset.value === 'black' ? values.black :
        button.dataset.value === 'wood' ? values.wood : values.unframed;
      selectNative(target || values.unframed);
      window.setTimeout(sync, 0);
    });

    picker.addEventListener('change', function () { window.setTimeout(sync, 0); });
    sync();
  }

  function enhanceStickyBuy(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.product-details .buy-buttons-block').forEach(function (buyButtons) {
      if (buyButtons.dataset.emmiStickyReady === 'true') return;
      buyButtons.dataset.emmiStickyReady = 'true';

      var anchor = document.createElement('span');
      anchor.className = 'emmi-buy-anchor';
      anchor.setAttribute('aria-hidden', 'true');
      buyButtons.before(anchor);

      function updateStickyBuy() {
        if (!anchor.isConnected) {
          if (buyButtons.isConnected && buyButtons.parentElement === document.body) {
            buyButtons.remove();
          }
          return;
        }
        if (!buyButtons.isConnected) return;

        var shouldStick = anchor.getBoundingClientRect().top < 0;
        var isSticky = buyButtons.classList.contains('emmi-buy-is-sticky');

        if (shouldStick && !isSticky) {
          anchor.style.height = buyButtons.offsetHeight + 'px';
          buyButtons._emmiStickyAnchor = anchor;
          buyButtons.classList.add('emmi-buy-is-sticky');
          document.body.appendChild(buyButtons);
        } else if (!shouldStick && isSticky) {
          anchor.after(buyButtons);
          buyButtons.classList.remove('emmi-buy-is-sticky');
          anchor.style.height = '0px';
        } else if (shouldStick) {
          anchor.style.height = buyButtons.offsetHeight + 'px';
        }
      }

      var scrollContainer = anchor.parentElement;
      while (scrollContainer && scrollContainer !== document.body) {
        var overflowY = window.getComputedStyle(scrollContainer).overflowY;
        if (/(auto|scroll|overlay)/.test(overflowY)) break;
        scrollContainer = scrollContainer.parentElement;
      }
      if (!scrollContainer || scrollContainer === document.body) scrollContainer = window;

      scrollContainer.addEventListener('scroll', updateStickyBuy, { passive: true });
      if (scrollContainer !== window) {
        window.addEventListener('scroll', updateStickyBuy, { passive: true });
      }
      window.addEventListener('resize', updateStickyBuy);
      updateStickyBuy();
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;

    document.querySelectorAll('body > .buy-buttons-block.emmi-buy-is-sticky').forEach(function (buyButtons) {
      if (!buyButtons._emmiStickyAnchor || !buyButtons._emmiStickyAnchor.isConnected) {
        buyButtons.remove();
      }
    });

    scope.querySelectorAll('variant-picker').forEach(enhance);
    enhanceStickyBuy(scope);
  }

  var queued = false;
  function queueInit() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      init(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  new MutationObserver(queueInit).observe(document.documentElement, { childList: true, subtree: true });
})();
